import React from 'react';
import { LayoutIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Sophie Williams',
  title: 'Graphic Designer',
  specialties: ['Book Layout', 'Marketing Materials', 'Social Media'],
  rating: 4.8,
  reviewCount: 112,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$200-600'
}, {
  id: '2',
  name: 'James Wilson',
  title: 'Publication Designer',
  specialties: ['Editorial Design', 'Brand Identity', 'Print Design'],
  rating: 4.7,
  reviewCount: 95,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$250-750'
}];
const GraphicDesigners = () => <CreativeDirectoryPage title="Graphic Designers" subtitle="Connect with professional graphic designers specializing in book design and marketing materials" icon={<LayoutIcon className="h-8 w-8" data-id="element-9305" data-mp="2ucssgz7sji96" />} profileBasePath="/creative/graphic-designers" artists={artists} data-id="element-9304" data-mp="l3jsamff274h" />;
export default GraphicDesigners;